// This file was automatically generated from render.reportFeedItem.resultGrid.html.
// Please don't edit this file by hand.

goog.provide('el8.template.render.reportFeedItem.resultGrid');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.model.lab');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reportFeedItem.resultGrid.prevResultQtip = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('Value: ');
  el8.template.ptdata.model.lab.displayValue(opt_data.prevResult, output);
  output.append('<br>Collected: ', (soy.$$escapeHtml(opt_data.prevResult.collectedDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.prevResult.collectedDate)) : ''), '<br>Ref Range: ');
  el8.template.ptdata.model.lab.reference(opt_data, output);
  output.append('<br>', (opt_data.prevResult.documentingPersonnelName) ? 'Documented by: ' + soy.$$escapeHtml(opt_data.prevResult.documentingPersonnelName) : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reportFeedItem.resultGrid.resultRow = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.textReportResultValue) {
    output.append('<li id="labResult_', soy.$$escapeHtml(opt_data.id), '" class="itemNoAction lgFont"><pre class="el8Preserve">', soy.$$escapeHtml(opt_data.textReportResultValue), (opt_data.isCancelledNonPerformance) ? '*' : '', '</pre></li>');
  } else if (opt_data.valueType == 'TX') {
    output.append('<li id="labResult_', soy.$$escapeHtml(opt_data.id), '" class="itemNoAction lgFont"><pre class="el8Preserve ', (opt_data.isAbnormal) ? 'abnormal' : '', '">');
    if (opt_data.abnormalFlag) {
      output.append('<span class="labValue" refRange=\'');
      el8.template.ptdata.model.lab.reference(opt_data, output);
      output.append('\'', (opt_data.isAbnormal) ? ' abnormalFlag="' + soy.$$escapeHtml(opt_data.abnormalFlag) + '"' : '', (opt_data.abnormalDescription) ? ' abnormalDesc="' + soy.$$escapeHtml(opt_data.abnormalDescription) + '"' : '', (opt_data.location) ? ' loc="' + soy.$$escapeHtml(opt_data.location.locationName) + '"' : '', (opt_data.documentingPersonnelName) ? ' documenter="' + soy.$$escapeHtml(opt_data.documentingPersonnelName) + '"' : '', (opt_data.value) ? 'value="' + soy.$$escapeHtml(opt_data.value) + '"' : '', '><span class="abnormalFlag">', soy.$$escapeHtml(opt_data.abnormalFlag), '</span></span>&nbsp;');
    }
    output.append((opt_data.labTest) ? soy.$$escapeHtml(opt_data.labTest.name) : '', (opt_data.value) ? ' ' + soy.$$escapeHtml(opt_data.value) : '', (opt_data.isCancelledNonPerformance) ? '*' : '', '</pre></li>');
  } else {
    output.append('<li id="labResult_', soy.$$escapeHtml(opt_data.id), '" class="result-row ', (opt_data.hasActions) ? 'am-highlight el8ItemHover' + ((opt_data.isStarred) ? ' starred' : '') : '', '">', (opt_data.hasActions) ? '<div class="el8ItemButtonContainer"><button type="button" tabindex="-1" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '" resultId="' + soy.$$escapeHtml(opt_data.id) + '" class="el8button result-row-actions-trigger el8ActionButton">Actions<span class="el8ButtonDropdownIcon"></span></button></div>' : '', '<div class="labResultRow">', (opt_data.hasActions) ? '<div class="labStar fl"><a class="star-trigger star" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '" resultId="' + soy.$$escapeHtml(opt_data.id) + '"></a></div>' : '', '<div class="labResultName fl ', (opt_data.isAbnormal) ? 'abnormal' : '', ' ', (! opt_data.hasActions) ? 'padl20' : '', '">', (opt_data.labTest) ? soy.$$escapeHtml(opt_data.labTest.name) : '', '</div><div class="labValue fl" refRange=\'');
    el8.template.ptdata.model.lab.reference(opt_data, output);
    output.append('\'', (opt_data.isAbnormal) ? ' abnormalFlag="' + soy.$$escapeHtml(opt_data.abnormalFlag) + '"' : '', (opt_data.abnormalDescription) ? ' abnormalDesc="' + soy.$$escapeHtml(opt_data.abnormalDescription) + '"' : '', (opt_data.location) ? ' loc="' + soy.$$escapeHtml(opt_data.location.locationName) + '"' : '', (opt_data.documentingPersonnelName) ? ' documenter="' + soy.$$escapeHtml(opt_data.documentingPersonnelName) + '"' : '', (opt_data.value) ? 'value="' + soy.$$escapeHtml(opt_data.value) + '"' : '', '><div class="labResultValue">');
    el8.template.render.reportFeedItem.resultGrid.manualDocIcon({documentingPersonnelType: opt_data.documentingPersonnelType}, output);
    output.append((opt_data.isAbnormal) ? '<span class="abnormal">' + ((opt_data.isCancelledNonPerformance) ? 'n/a*' : soy.$$escapeHtml(opt_data.value)) + '</span>' + ((opt_data.abnormalFlag) ? '<span class="abnormalFlag">' + soy.$$escapeHtml(opt_data.abnormalFlag) + '</span>' : '') : (opt_data.isCancelledNonPerformance) ? 'n/a*' : soy.$$escapeHtml(opt_data.value), '</div></div>');
    if (opt_data.prevResults) {
      var prevResultList30297 = opt_data.prevResults;
      var prevResultListLen30297 = prevResultList30297.length;
      for (var prevResultIndex30297 = 0; prevResultIndex30297 < prevResultListLen30297; prevResultIndex30297++) {
        var prevResultData30297 = prevResultList30297[prevResultIndex30297];
        if (prevResultData30297) {
          output.append('<div class="labPreviousValue fl" resultinfo=\'');
          el8.template.render.reportFeedItem.resultGrid.prevResultQtip(soy.$$augmentData(opt_data, {prevResult: prevResultData30297}), output);
          output.append('\'>');
          if (prevResultData30297.documentingPersonnelName) {
            output.append('<div class="labPreviousValueInput">');
            el8.template.render.reportFeedItem.resultGrid.smallManualDocIcon({documentingPersonnelType: prevResultData30297.documentingPersonnelType}, output);
            if (prevResultData30297.isAbnormal) {
              output.append('<span class="abnormal">');
              el8.template.ptdata.model.lab.displayValue(prevResultData30297, output);
              output.append('</span>');
            } else {
              el8.template.ptdata.model.lab.displayValue(prevResultData30297, output);
            }
            output.append('</div>');
          } else {
            if (prevResultData30297.isAbnormal) {
              output.append('<span class="abnormal">');
              el8.template.ptdata.model.lab.displayValue(prevResultData30297, output);
              output.append('</span>');
            } else {
              el8.template.ptdata.model.lab.displayValue(prevResultData30297, output);
            }
          }
          output.append('</div>');
        } else {
          output.append('<div class="labPreviousValueNull fl">n/a</div>');
        }
      }
    }
    output.append('</div><div class="note"><div resultId="', soy.$$escapeHtml(opt_data.id), '" class="labNote fl"><span class="labNoteInstr"></span></div></div></li>');
  }
  output.append((opt_data.isCancelledNonPerformance) ? '<li class="itemInstr"><div class="labResultValueNote"><pre class="el8Preserve">* Results cancelled due to non-performance</pre></div></li>' : '', (opt_data.resultValueNote) ? '<li class="itemInstr result-value-note ' + ((opt_data.isResultValueNoteFormatted) ? 'el8OverflowXScroll' : '') + '"><div class="labResultValueNote"><pre class="' + ((! opt_data.isResultValueNoteFormatted) ? 'el8Preserve' : '') + '">' + soy.$$escapeHtml(opt_data.resultValueNote) + '</pre></div></li>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reportFeedItem.resultGrid.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="header"><div class="labResultRow">', (opt_data.isTxResultOnly) ? '<div class="labPreviousValueHeader fl">&nbsp;</div>' : '<div class="labResultNameHeader fl">Test</div><div class="labValueHeader fl">Value</div><div class="labPreviousValueHeader fl">Last 3 Values</div>', '</div></li>');
  var categoryList30356 = opt_data.resultsByCategory;
  var categoryListLen30356 = categoryList30356.length;
  for (var categoryIndex30356 = 0; categoryIndex30356 < categoryListLen30356; categoryIndex30356++) {
    var categoryData30356 = categoryList30356[categoryIndex30356];
    output.append('<li class="labCategoryHeader"><div class="label">', soy.$$escapeHtml(categoryData30356.label), '</div>', (opt_data.status == 'PENDING') ? '<span class="labResultValue">PENDING</span>' : '');
    var rowList30363 = categoryData30356.rows;
    var rowListLen30363 = rowList30363.length;
    for (var rowIndex30363 = 0; rowIndex30363 < rowListLen30363; rowIndex30363++) {
      var rowData30363 = rowList30363[rowIndex30363];
      el8.template.render.reportFeedItem.resultGrid.resultRow(soy.$$augmentData(rowData30363, {feedItemId: opt_data.feedItemId, hasActions: opt_data.hasActions}), output);
    }
    output.append('</li>');
  }
  output.append((opt_data.labReportNote) ? '<li class="itemNoAction"><div class="labReportNote"><pre class="el8Preserve">' + soy.$$escapeHtml(opt_data.labReportNote) + '</pre></div></li>' : '', '<li class="cardDateDetails">', (opt_data.lastManualEditTime) ? '<p class="el8SignoffText el8Wrap">Documented by ' + soy.$$escapeHtml(opt_data.lastManualEditUserName) + ' on ' + soy.$$escapeHtml(opt_data.lastManualEditTime) + '</p>' : '<div class="cardColumn fr w49"><div class="reportInfoType fl">Status:</div><div class="reportInfoDate">' + soy.$$escapeHtml(opt_data.status) + '</div>' + ((opt_data.accessionNumber) ? '<div class="reportInfoType fl">Accession No.:</div><div class="reportInfoDate">' + soy.$$escapeHtml(opt_data.accessionNumber) + '</div>' : '') + '</div><div class="cardColumn w50"><div class="reportInfoType fl">Collected:</div>' + ((opt_data.isCollectedDateProvided) ? '<div class="reportInfoDate">' + (soy.$$escapeHtml(opt_data.collectedDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.collectedDate)) : '') + '</div>' : '<div class="reportInfoDate">Not Provided</div>') + '<div class="reportInfoType fl">Completed:</div><div class="reportInfoDate">' + (soy.$$escapeHtml(opt_data.resultedDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.resultedDate)) : '') + '</div></div>', '</li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reportFeedItem.resultGrid.manualDocIcon = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.documentingPersonnelType) ? (opt_data.documentingPersonnelType == 'Physician') ? '<div class="el8PhysicianInputIcon el8ResultInputIconPosition"></div>' : '<div class="el8StaffInputIcon el8ResultInputIconPosition"></div>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reportFeedItem.resultGrid.smallManualDocIcon = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.documentingPersonnelType) ? (opt_data.documentingPersonnelType == 'Physician') ? '<div class="small-manual-doc-item el8PhysicianInputIconSmall el8ResultInputIconSmallPosition" data-personnel-id="' + soy.$$escapeHtml(opt_data.documentingPersonnelId) + '"></div>' : '<div class="small-manual-doc-item el8StaffInputIconSmall el8ResultInputIconSmallPosition" data-personnel-id="' + soy.$$escapeHtml(opt_data.documentingPersonnelId) + '"></div>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reportFeedItem.resultGrid.manualPlrDocIcon = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8PlrInputIcon el8ResultInputIconSmallPosition"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reportFeedItem.resultGrid.smallManualPlrDocIcon = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8PlrInputIconSmall el8ResultInputIconSmallPosition"></div>');
  if (!opt_sb) return output.toString();
};
